import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TrainingOverviewPage } from './training-overview';

@NgModule({
  declarations: [
    TrainingOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(TrainingOverviewPage),
  ],
})
export class TrainingOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/training-overview/training-overview.module.ts